module.exports = __webpack_public_path__ + "img/31.61bc749c.jpg";